export default __webpack_public_path__ + "static/media/picth_video_final.f3783dcb.mp4";